<template>
  <div class="big benevolenceValue">
    <div class="page_title">医生活动</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="top-header">
          <div class="search-box">
            <!-- 活动名称 -->
            <div class="item">
              <span>活动名称</span>
              <div class="item-content">
                <el-input
                  v-model="doctorActivity.act_name"
                  size="small"
                  clearable
                  @keyup.enter.native="seachEnterFun"
                  placeholder="活动名称"
                ></el-input>
              </div>
            </div>

            <!-- 活动状态 -->
            <div class="item">
              <span style="margin-left: 10px">活动状态</span>
              <div class="item-content">
                <el-select
                  v-model="doctorActivity.status"
                  size="small"
                  placeholder="请选择"
                  @change="seachEnterFun"
                >
                  <el-option
                    v-for="item in selectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 20px"
                @click="getList"
                >查询</el-button
              >
              <el-button size="small" @click="restBtn">重置</el-button>
            </div>
          </div>
          <!-- 新增活动 -->
          <div style="margin-bottom: 10px">
            <el-button
              type="primary"
              size="medium"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1073') : false
              "
              @click="toActivity(-1)"
              >新增活动</el-button
            >
            <el-button
              type="primary"
              size="medium"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('2013') : false
              "
              @click="toShopSet"
              >商品兑换配置</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="benevolenceData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'start_time'">
                  {{ scope.row[item.prop] | dateFormat }} -
                  {{ scope.row["end_time"] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'doctor_auth'">
                  {{ scope.row[item.prop] | doctorAuthText }}
                </div>

                <div v-else-if="item.prop == 'status'">
                  {{ scope.row[item.prop] | statusText }}
                </div>
                <div v-else>
                  {{ !scope.row[item.prop] ? "" : scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="220"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  @click="toDetail(scope.row.act_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1072')
                      : false
                  "
                  >查看</el-button
                >
                <el-button type="text" @click="openUrl(scope.row.act_url)"
                  >链接</el-button
                >
                <el-button
                  type="text"
                  @click="edit(scope.row)"
                  v-if="scope.row.status == 1 || scope.row.status == 2"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1074')
                      : false
                  "
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  @click="toStatistics(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1076')
                      : false
                  "
                  >统计</el-button
                >
                <el-button
                  v-if="scope.row.status !== 4"
                  type="text"
                  @click="delActivity(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1071')
                      : false
                  "
                  >作废</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      selectOptions: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "未开始",
        },
        {
          value: 2,
          label: "进行中",
        },
        {
          value: 3,
          label: "已结束",
        },
        {
          value: 4,
          label: "已作废",
        },
      ],
      doctorActivity: {
        act_name: "",
        status: "",
      },
      tableHeader: [
        {
          label: "活动名称",
          prop: "act_name",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "创建时间",
          prop: "create_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "活动备注",
          prop: "remark",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "活动时间",
          prop: "start_time",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "参与类型",
          prop: "doctor_auth",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "活动状态",
          prop: "status",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      benevolenceData: [],
      doctor_info: {},
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
    doctorAuthText(val) {
      switch (val) {
        case 1:
          return "全部医生";
        case 2:
          return "部分医生参与";
        case 3:
          return "部分医生不参与";
      }
    },
    statusText(val) {
      switch (val) {
        case 1:
          return "未开始";
        case 2:
          return "进行中";
        case 3:
          return "已结束";
        case 4:
          return "已作废";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign(this.pagination, this.doctorActivity);
      this.tableLoading = true;
      marketing.doctorHeartActivityList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.benevolenceData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    // 查看
    toDetail(act_id) {
      this.$router.push({
        path: "/home/marketing/addOrEditActivity",
        query: {
          act_id,
          type: 3,
        },
      });
    },
    // 添加
    toActivity(act_id) {
      this.$router.push({
        path: "/home/marketing/addOrEditActivity",
        query: {
          act_id,
          type: 1,
        },
      });
    },
    //编辑活动
    edit(row) {
      this.$router.push({
        path: "/home/marketing/addOrEditActivity",
        query: {
          act_id: row.act_id,
          type: row.status == 1 ? 4 : 2,
        },
      });
    },
    //统计
    toStatistics(row) {
      let { act_id, start_time, end_time } = row;
      this.$router.push({
        path: "/home/marketing/doctorActivityStatistics",
        query: {
          act_id,
          start_time,
          end_time,
        },
      });
    },
    //作废
    delActivity(row) {
      let { act_id, status, act_name } = row;
      if (status == 1 || status == 2) {
        this.$confirm(
          `确定作废活动【${act_name}】吗？作废后将无法恢复`,
          "提示",
          {
            confirmButtonText: "确定作废",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            marketing.isCancelDoctorHeartActivity({ act_id }).then((res) => {
              if (res.code == 0) {
                this.$message.success("操作成功");
                this.getList();
              }
            });
          })
          .catch(() => {});
      }

      if (status == 3) {
        this.$message.error(`活动【${act_name}】已经结束，无法作废`);
        return false;
      }
    },
    //打开链接
    openUrl(act_url) {
      this.$confirm(act_url, "链接", {
        confirmButtonText: "复制",
        cancelButtonText: "取消",
      })
        .then(() => {
          let oInput = document.createElement("input");
          oInput.value = act_url;
          document.body.appendChild(oInput);
          oInput.select();
          document.execCommand("Copy");
          oInput.remove();
          this.$message({
            message: "复制成功",
            type: "success",
          });
        })
        .catch(() => {});
    },
    restBtn() {
      for (let key in this.doctorActivity) {
        if (key == "create_time") {
          this.doctorActivity[key] = [];
        } else {
          this.doctorActivity[key] = "";
        }
      }
      this.getList();
    },
    // 商品配置页面
    toShopSet() {
      this.$router.push({
        path: "/home/marketing/shopExchangeSet",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.benevolenceValue {
  .top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
